import React, { useEffect, useState } from "react";
import { Fab, Tooltip, Zoom } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

// ปุ่มลอยกลับขึ้นบนสุด — โผล่เมื่อเลื่อนลงเกิน 400px
export default function ScrollTopButton() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Zoom in={show}>
      <Tooltip title="กลับขึ้นด้านบน" placement="left">
        <Fab
          aria-label="scroll to top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          size="medium"
          sx={{
            position: "fixed",
            right: { xs: 16, md: 28 },
            bottom: { xs: "calc(16px + env(safe-area-inset-bottom))", md: 28 },
            zIndex: 1200,
            color: "white",
            background: "linear-gradient(135deg, #2e7d32 0%, #7cb342 100%)",
            boxShadow: "0 8px 24px rgba(46,125,50,0.4)",
            "&:hover": { background: "linear-gradient(135deg, #1b5e20 0%, #689f38 100%)", transform: "translateY(-2px)" },
            transition: "transform 0.2s ease",
          }}
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </Tooltip>
    </Zoom>
  );
}
